import { get, post } from './http-calls';

export let getRenaultJobDetails = async (smn) => {
    let data = await get(`WorkflowJobs/GetJobDetails?HeaderRecordID=${smn}`, { useAuthToken: true });
    return data;
};
